module.exports = __webpack_public_path__ + "static/media/nostalgia.ac45ea95.png";